export default __webpack_public_path__ + "static/media/banner_4.148e0f41.png";